/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_Space_SuccessInputs */



/**
* | output |
* | --- |
* | "Space created successfully!" |
*
* @param {Spaces_Create_Space_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_space_success = /** @type {((inputs?: Spaces_Create_Space_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_Space_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherplatz erfolgreich erstellt!")
	return /** @type {LocalizedString} */ ("Space created successfully!")
});